export { default } from './MandiEditAttributesModalConnector';

